import { Component, OnInit, Input, OnDestroy, TemplateRef, ViewChild } from "@angular/core";
import { IUserAccount, Page } from "@shared/models";
import { HttpService, PrintOptionService, BannerService, ResourceService, AppData, NotifyService } from "@shared/services";
import { takeUntil, finalize } from "rxjs/operators";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ApiResources, UtilHelper } from "@shared/helpers";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { PayTypes } from "@shared/entities/paytype.entity";
class RegistrationBill {
    patientRegistrationDetailId: number;
    charge: number;
    patientId: number;
    createdBy: number;
    createdDate: Date;
    createdByName: string;
    patientName: string;
    gender: string;
    age?: number;
    payTypeId?: number;
    payTypeName: string;
    amount: number;
    discount: number;
    paymentDetails: string;
    umrNo: string;
    payTypes: Array<PayTypes>;
    paymentType: string;
    
    remainingAmoint: number;
    total: number;

}
@Component({
    templateUrl: "./patient-registration-invoice.html",
    styleUrls: ['./patient-registration-invoice.widget.css'],
    selector: "patient-registration-invoice",
})

export class PatientRegistrationInvoiceWidget implements OnInit, OnDestroy {
    @ViewChild("templateRegistrationBill", { static: true }) templateRegistrationBill: TemplateRef<any>;
    @Input() patientId: number;
    @Input() isPrintLogo: boolean;
    page: Page;
    loading: boolean;
    date: Date;
    modalRef: NgbModalRef;
    submitting: boolean;
    registrationBill: Array<RegistrationBill>;
    registrationBillPat: Array<RegistrationBill>;
    saveRelativeAsPatient: boolean;
    currentDate: Date;
    paidAmount = 0;
    todayDate: Date;
    totalAmount: number;
    constructor(
        private readonly httpService: HttpService,
        private readonly printOptionService: PrintOptionService,
        private readonly bannerService: BannerService,
        private readonly appData: AppData,
        private readonly resourceService: ResourceService,
        private readonly modalService: NgbModal,
        private readonly notifyService: NotifyService,
        private readonly router: Router
    ) {
        this.page = new Page();
        this.todayDate = new Date();
        this.registrationBillPat = new Array<RegistrationBill>();
    }
    


    onCheckRegistration() {
        this.submitting = true;
        this.httpService.get<Array<RegistrationBill>>(ApiResources.getURI(ApiResources.patients.base, ApiResources.patients.fetchPatientInvoice), { id: this.patientId })
            .pipe(
                takeUntil(this.page.unSubscribe),
                finalize(() => this.submitting = false)
            )
            .subscribe(
                (response: Array<RegistrationBill>) => {
                    if (response) {
                        this.registrationBill = response;
                        this.registrationBill.forEach((m) => {
                            this.paidAmount += m.charge;
                        });
                        this.totalAmount = this.registrationBill[0].total - this.paidAmount;

                        this.currentDate = new Date();
                    }
                },
                (error: HttpErrorResponse) => {
                    const errorMessage = UtilHelper.handleError(error);
                    if (errorMessage) {
                        this.notifyService.warningToast(errorMessage);
                    } else {
                        this.notifyService.defaultError();
                    }
                }
            );
    }



    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    this.onCheckRegistration();
                } else {
                    this.page.userAccount = undefined;
                }

            });
    }
    ngOnDestroy() {
        this.page.unsubscribeAll();
        this.page.unSubscribe.complete();
    }

    onChangePrintType(type: boolean) {
        this.isPrintLogo = type;
    }
}